import { IFIReportType } from '@cims-online/shared'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { useProjectSettingsContext } from '../../../../ProjectSettingsContext'
import { useState } from 'react'
import DirtyHeader from '../../components/DirtyHeader'
import EnabledIndicator from '../../components/EnabledIndicator'
import InspectionViewPanel from './components/InspectionViewPanel'
import InspectionEditPanel from './components/InspectionEditPanel'
import { InspectionPanelName } from './types'
import { NestedCollapseProps } from '../common'

const useInspectionPanel = (
  collapseProps: NestedCollapseProps
): CIMSCollapsePanelOptions => {
  const {
    inspectionIFISettings: { data },
    canEdit,
  } = useProjectSettingsContext()
  const [dirtyPanels, setDirtyPanels] = useState<InspectionPanelName[]>([])

  return {
    header: {
      children: (
        <DirtyHeader
          title={IFIReportType.DailyInspectionInspection.type}
          isDirty={dirtyPanels.length > 0}
        />
      ),
    },
    key: IFIReportType.DailyInspectionInspection.id,
    extra: {
      children: <EnabledIndicator enabled={data?.enabled} />,
    },
    children: canEdit ? (
      <InspectionEditPanel
        {...{ dirtyPanels, setDirtyPanels, ...collapseProps }}
      />
    ) : (
      <InspectionViewPanel />
    ),
  }
}

export default useInspectionPanel
